// Global Instructions Rule Applied!
import React from 'react'
import { Card, Typography } from 'antd'
import Button from '../components/Button.jsx'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle, faSignOutAlt } from '@fortawesome/free-solid-svg-icons'
import { useDispatch } from 'react-redux'
import { supabase } from '../lib/supabase'
import { logout } from './authSlice'

const { Title, Text } = Typography

/**
 * UnauthorizedScreen Component
 *
 * Displays when a user is authenticated but their email domain
 * is not authorized to access the application
 */
function UnauthorizedScreen() {
  const dispatch = useDispatch()

  const handleSignOut = async () => {
    try {
      await supabase.auth.signOut()
      dispatch(logout())
    } catch (error) {
      console.error('Error signing out:', error)
      // Force logout even if Supabase call fails
      dispatch(logout())
    }
  }

  return (
    <div className='min-h-dvh bg-gray-50 flex items-center justify-center p-4'>
      <Card className='max-w-md w-full text-center shadow-lg p-4'>
        <div className='mb-6'>
          <FontAwesomeIcon icon={faExclamationTriangle} className='text-6xl text-red-500 mb-4' />
          <Title level={2} className='text-red-600 mb-2'>
            Access Denied
          </Title>
          <Text className='text-gray-600 text-lg'>You are not authorized to access this application.</Text>
        </div>

        <div className='mb-6'>
          <Text className='text-gray-500'>Please contact your administrator if you believe this is an error.</Text>
        </div>

        <Button
          variant='primary'
          size='large'
          icon={<FontAwesomeIcon icon={faSignOutAlt} />}
          onClick={handleSignOut}
          className='w-96 mt-2 mb-2'
        >
          Sign Out
        </Button>
      </Card>
    </div>
  )
}

export default UnauthorizedScreen
